import * as React from "react";
import * as style from "./Video.style";

const Video: React.FC = () => {
  return (
    <div className={style.component}>
      <div className={style.wrapper}>
        <iframe
          className={style.iframe}
          src="https://www.youtube.com/embed/RVzPlH7rlPA"
          title="The Octolounge"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      </div>
    </div>
  );
};

Video.displayName = "Video";
export { Video };
